// // create a container and set the full-size image as its background
// function createOverlay(image) {
//   const overlayImage = document.createElement('img');
//   overlayImage.setAttribute('src', `${image.src}`);
//   overlay = document.createElement('div');
//   prepareOverlay(overlay, overlayImage);

//   image.style.opacity = '50%';
//   toggleLoadingSpinner(image);

//   overlayImage.onload = () => {
//     toggleLoadingSpinner(image);
//     image.parentElement.insertBefore(overlay, image);
//     image.style.opacity = '100%';
//   };

//   return overlay;
// }

// function prepareOverlay(container, image) {
//   container.setAttribute('class', 'image-magnify-full-size');
//   container.setAttribute('aria-hidden', 'true');
//   container.style.backgroundImage = `url('${image.src}')`;
//   container.style.backgroundColor = 'var(--gradient-background)';
// }

// function toggleLoadingSpinner(image) {
//   const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
//   loadingSpinner.classList.toggle('hidden');
// }

// function moveWithHover(image, event, zoomRatio) {
//   // calculate mouse position
//   const ratio = image.height / image.width;
//   const container = event.target.getBoundingClientRect();
//   const xPosition = event.clientX - container.left;
//   const yPosition = event.clientY - container.top;
//   const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
//   const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

//   // determine what to show in the frame
//   overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
//   overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
// }

// function magnify(image, zoomRatio) {
//   const overlay = createOverlay(image);
//   overlay.onclick = () => overlay.remove();
//   overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
//   overlay.onmouseleave = () => overlay.remove();
// }

// function enableZoomOnHover(zoomRatio) {
//   const images = document.querySelectorAll('.image-magnify-hover');
//   images.forEach((image) => {
//     image.onclick = (event) => {
//       magnify(image, zoomRatio);
//       moveWithHover(image, event, zoomRatio);
//     };
//   });
// }

// enableZoomOnHover(2);

(function () {
  const ZOOM = 2;

  function getActiveImg() {
    return document.querySelector(
      '.swiper-slide.swiper-slide-active img.image-magnify-hover'
    );
  }

  function enableMagnify(img) {
    if (img._magnifyEnabled) return;
    img._magnifyEnabled = true;

    let animFrame = null;

    function onMouseEnter() {
      img.style.transformOrigin = '0 0';
      img.style.transition = 'transform 0.1s ease';
      img.style.cursor = 'zoom-in';
    }

    function onMouseMove(e) {
      if (animFrame) cancelAnimationFrame(animFrame);
      animFrame = requestAnimationFrame(() => {
        const rect = img.getBoundingClientRect();
        const x = (e.clientX - rect.left) / rect.width;
        const y = (e.clientY - rect.top) / rect.height;

        img.style.transformOrigin = `${Math.max(0, Math.min(x * 100, 100))}% ${Math.max(0, Math.min(y * 100, 100))}%`;
        img.style.transform = `scale(${ZOOM})`;
      });
    }

    function onMouseLeave() {
      if (animFrame) cancelAnimationFrame(animFrame);
      img.style.transform = 'scale(1)';
      img.style.transition = 'transform 0.2s ease';
      img.style.cursor = '';
    }

    img.addEventListener('mouseenter', onMouseEnter);
    img.addEventListener('mousemove', onMouseMove);
    img.addEventListener('mouseleave', onMouseLeave);

    img._magnifyCleanup = function () {
      img.removeEventListener('mouseenter', onMouseEnter);
      img.removeEventListener('mousemove', onMouseMove);
      img.removeEventListener('mouseleave', onMouseLeave);
      img.style.transform = '';
      img.style.transformOrigin = '';
      img.style.transition = '';
      img.style.cursor = '';
      img._magnifyEnabled = false;
      delete img._magnifyCleanup;
    };
  }

  function disableMagnify(img) {
    if (img && img._magnifyCleanup) img._magnifyCleanup();
  }

  function refresh() {
    const img = getActiveImg();
    if (img) enableMagnify(img);
  }

  const swiperContainer =
    document.querySelector('.swiper') ||
    document.querySelector('.swiper-container');

  if (swiperContainer) {
    const observer = new MutationObserver(() => {
      document.querySelectorAll('.swiper-slide img.image-magnify-hover').forEach((img) => {
        const slide = img.closest('.swiper-slide');
        if (slide && !slide.classList.contains('swiper-slide-active')) {
          disableMagnify(img);
        }
      });
      refresh();
    });

    observer.observe(swiperContainer, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();
